import { FTProcessRow } from '@/models/FTProcessRow';
import _ from 'lodash';

export const slitting = ( processInputRow: FTProcessRow ) => {
  const outputs = _.map(processInputRow.ftProcess.outputs, (outputFTProcessRow: FTProcessRow) => {
    outputFTProcessRow.goodsObject.copyFrom(processInputRow.goodsObject);
    if (_.get(outputFTProcessRow, 'dimensions.width') && outputFTProcessRow.goodsObject.dimensions) {
      outputFTProcessRow.goodsObject.dimensions.width = outputFTProcessRow.dimensions.width;
    }
    return outputFTProcessRow;
  })
  return outputs;
}
